import { AnimatePresence, motion } from "framer-motion";
import { FunctionComponent, useEffect, useState } from "react";
import CartArticle from "@Components/molecules/cart/CartArticle";
import CartArticleRemove from "@Components/molecules/cart/CartArticle/CartArticleRemove";
import CartBottomSheet from "@Components/molecules/cart/CartBottomSheet";
import { Article } from "@Types/cart";

interface Props {
  article: Article;
  display: boolean;
  onDismiss: () => void;
}

const CartArticleBottomSheet: FunctionComponent<Props> = ({ article, display, onDismiss }) => {
  const [screen, setScreen] = useState<"article" | "remove">("article");

  useEffect(() => {
    setScreen("article");
  }, [display]);

  return (
    <CartBottomSheet display={display} onDismiss={onDismiss}>
      <AnimatePresence exitBeforeEnter>
        {screen === "article" && (
          <motion.div
            key="CartArticle"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
          >
            <CartArticle
              alternativeDesign={true}
              article={article}
              onClickRemove={() => setScreen("remove")}
            />
          </motion.div>
        )}

        {screen === "remove" && (
          <motion.div
            key="CartArticleRemove"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
          >
            <CartArticleRemove
              article={article}
              display={screen === "remove"}
              onBack={() => setScreen("article")}
              onDismiss={onDismiss}
              panel={false}
            />
          </motion.div>
        )}
      </AnimatePresence>
    </CartBottomSheet>
  );
};

export default CartArticleBottomSheet;
